import "./Experience.scss";
import Header from "../../components/Layout/Header/Header";
import Footer from "../../components/Layout/Footer/Footer";
import PdfViewer from "../../components/Layout/PdfViewer/PdfViewer";
// import cv from "../../assets/documents/alex-ross-cv.pdf";

function Experience() {
  return (
    <>
      <Header />
      <PdfViewer />
      <Footer />
    </>
  );
}

export default Experience;
